/**
 * Scopes card — README §6. Reused by connect step 1 (expanded) and the
 * Settings dialog's Scopes tab (footerNote copy differs between the two,
 * everything else is identical — "one component, two states").
 */
import React from "react";
import Card from "../../theme/untitled/Card/Card";
import ScopeRow from "./ScopeRow";
import ProviderSignInButton from "./ProviderSignInButton";
import appConfig from "../../../../appConfig";
import { SIGN_IN_PROVIDER } from "../../../../consts";
import styles from "./ScopesCard.module.scss";

const ScopesCard = ({
  provider,
  definitions,
  scopes,
  onScopeChange,
  footerNote,
  onSignIn,
  busy,
}) => {
  const signInProvider = SIGN_IN_PROVIDER[provider];
  const scopeRows = Object.keys(definitions).map((name) => (
    <ScopeRow
      key={name}
      name={name}
      definition={definitions[name]}
      checked={Boolean(scopes[name])}
      onChange={onScopeChange}
    />
  ));

  return (
    <Card className={styles.card}>
      <h3 className={styles.title}>Scopes</h3>
      <p className={styles.subtitle}>
        Use scopes to specify what data{" "}
        {appConfig.shortDisplayName || appConfig.displayName} should pull.
        Ensure you have granted required permissions.
      </p>
      <ul className={styles.list}>{scopeRows}</ul>
      <div className={styles.footer}>
        <p className={styles.footerNote}>{footerNote}</p>
        <ProviderSignInButton
          provider={signInProvider}
          onClick={onSignIn}
          disabled={busy}
        />
      </div>
    </Card>
  );
};

export default ScopesCard;
